import { InputBindingDevice } from "./InputBindingDevice.enum"
import { type GamepadBinding } from "./InputRouter"

export default function createGamepadBinding (
  button: number,
  gamepadIndex?: number,
): GamepadBinding {
  return {
    device: InputBindingDevice.Gamepad,
    button,
    gamepadIndex,
  }
}